import { FC, createRef, useEffect } from 'react';

import { CinemaCard } from './cinema-card';
import { CinemaModel } from '@/logic/services/cinemas';
import { GridLegacy as Grid } from '@mui/material';
import { useScrollToItem } from '@/logic/hooks';

interface CinemasProps {
  cinemas: CinemaModel[];
  scrolledToCinema: number;
}

export const Cinemas: FC<CinemasProps> = ({ cinemas, scrolledToCinema }) => {
  const { scrollToItem } = useScrollToItem();

  const refsList = cinemas?.reduce((acc, value) => {
    acc[value.id] = createRef();
    return acc;
  }, {});

  useEffect(() => {
    if (!!scrolledToCinema && !!refsList) scrollToItem(refsList[scrolledToCinema]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrolledToCinema, refsList]);

  return (
    <Grid container spacing={2}>
      {cinemas?.map(cinema => (
        <Grid key={cinema.id} item mobile={12} tablet={6} ref={refsList[cinema.id]}>
          <CinemaCard cinema={cinema} />
        </Grid>
      ))}
    </Grid>
  );
};
